import { ManagerRole } from '../../../../hooks/auth/usePermissions';

export default {
  [ManagerRole.SuperAdmin]: 'Super admin',
  [ManagerRole.Admin]: 'Admin',
  [ManagerRole.SalesManager]: 'Menedżer sprzedaży',
  [ManagerRole.SalesLeadership]: 'Kierownictwo sprzedaży',
  [ManagerRole.ContentManager]: 'Menedżer treści',
  [ManagerRole.OnboardingManager]: 'Menedżer wdrożeń',
  [ManagerRole.OccAgent]: 'Agent call center',
};
